import { AssetViews } from 'pages/assetDatabase/assetOverview/header/AssetHeader'
import { SEARCH_PARAM_UNIT_ID } from 'routes/(common_search_params)/-searchParams'
import { SEARCH_PARAM_SITE_ID } from 'routes/(global_search_params)/-searchParams'
import { z } from 'zod'

export const assetLifecyclePageSearchSchema = z.object({
  [SEARCH_PARAM_UNIT_ID]: z.string().optional(),
  [SEARCH_PARAM_SITE_ID]: z.string(),
  view: z.string().default('details'),
  fileId: z.string().optional(),
})

export const assetLifecycleDebugSearchSchema = z.preprocess(
  (value) => (value === 1 ? '1' : value),
  z.literal('1').optional()
)

export const assetUnitPageSearchSchema = z.object({
  [SEARCH_PARAM_UNIT_ID]: z.string().catch(''),
  [SEARCH_PARAM_SITE_ID]: z.string(),

  view: z
    .enum(Object.values(AssetViews) as [string, ...string[]])
    .default(AssetViews.DETAILS),
  // Table state parameters
  sortBy: z.string().optional(),
  sortDesc: z.boolean().optional(),
  filters: z
    .record(
      z.string(),
      z.union([
        z.string(),
        z.number(),
        z.boolean(),
        z.array(z.string()),
        z.tuple([z.string().nullable(), z.string().nullable()]),
      ])
    )
    .optional(),
})

export const assetRoutingSearchParams = assetLifecyclePageSearchSchema.extend(
  assetUnitPageSearchSchema.shape
)
